import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/vendor-profiles',
    name: 'vendor-profile',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/vendor-profile/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('administration/vendorProfile/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/vendor-profiles/:id',
    name: 'vendor-profile-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/vendor-profile/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('administration/vendorProfile/dataBeforeCreate')
      await store.dispatch('administration/vendorProfile/find', to.params.id)
      next()
    }
  }
]
